import React from 'react'

export default class Checkbox extends React.Component {
  render() {
    const { checked, name, label, message } = this.props

    return (
      <React.Fragment>
        <div className="checkbox">
          <div>
            <input
              type="checkbox"
              name={name}
              checked={checked}
              onChange={() => this.props.handleUpdate(!checked)}
            />
            <label htmlFor={name}>{label}</label>
          </div>
          {message && <span>{message}</span>}
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Checkbox.js